import { RoleDTO } from '../services/userService';
import { Permissions } from '../constants/Permissions';

/**
 * Access permissions that bind a user to a physical outlet — a cashier, waiter or
 * kitchen user works the floor of one outlet. Mirrors the backend's
 * OutletBoundAccessPermissions set (UserService), which is the actual enforcer.
 */
const OUTLET_BOUND_PERMISSIONS: string[] = [
  Permissions.Cashier.Access,
  Permissions.Waiter.Access,
  Permissions.Kitchen.Access,
];

/**
 * True when any of the selected roles grants a floor-access permission, meaning the
 * user must be assigned to an outlet. Keyed off the permission, not the role name,
 * so renamed roles still resolve correctly.
 */
export const rolesRequireOutlet = (roles: RoleDTO[], selectedRoleIds: number[]): boolean =>
  roles
    .filter((r) => selectedRoleIds.includes(r.id))
    .some((r) => (r.permissions ?? []).some((p) => OUTLET_BOUND_PERMISSIONS.includes(p.code)));
